__turbopack_context__.v({
  "discount": "product-price-widget-module-scss-module__yOvvdG__discount",
  "main": "product-price-widget-module-scss-module__yOvvdG__main",
  "root": "product-price-widget-module-scss-module__yOvvdG__root",
});
